import { required } from 'vuelidate/lib/validators';
import offset from 'document-offset';
import VueFeedback from '@ui-common/vue-feedback';
import messages from './complaints-success-lang.json';
export default {
	i18n: { messages },
	data() {
		return {
			dots: []
		};
	},
	components: { VueFeedback },
	props: {
		email: { required }
	},
	watch: {},
	methods: {},
	mounted() {
		this.$nextTick(() => {
			window.scroll(0, offset(this.$el).top);
		});
	}
};
